module.exports = __webpack_public_path__ + "img/publish1.585f0d87.png";